import { Button, TextInput } from 'components/Form'
import { HiOutlineUser } from 'react-icons/hi'
import { Link, useNavigate } from 'react-router-dom'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import useAuth from 'utils/hooks/useAuth'
import { Success } from 'utils/alerts'

const validationSchema = Yup.object().shape({
    email: Yup.string().required('email is required'),
    password: Yup.string().required('Password is required'),
})

export default function Login() {
    const navigate = useNavigate()
    const { signIn } = useAuth()

    const onSignIn = async (values, setSubmitting) => {
        const { email, password } = values
        setSubmitting(true)
        const result = await signIn({ email, password })

        if (result.status === 'verify') {
            navigate('/verify')
        } else if (result.status !== 'failed') {
            Success('Login successfully!')
            navigate('/')
        }
        setSubmitting(false)
    }

    return (
        <>
            <span className="flex justify-center">
                <img className="w-[40%] h-[40%]" src="/images/logo.png" alt="error" />
            </span>
            <Formik
                initialValues={{
                    email: '',
                    password: '',
                }}
                validationSchema={validationSchema}
                onSubmit={(values, { setSubmitting }) => {
                    onSignIn(values, setSubmitting)
                }}
            >
                {({ touched, errors, isSubmitting }) => (
                    <Form className="flex flex-col gap-6">
                        <Field name="email">
                            {({ field, form }) => (
                                <TextInput
                                    type="text"
                                    id="email"
                                    name="email"
                                    className="font-medium"
                                    placeholder={'Enter your email here'}
                                    autoComplete="email"
                                    isFocused={true}
                                    icon={<HiOutlineUser />}
                                    error={errors.email && touched.email}
                                    message={errors.email}
                                    onChange={e => form.setFieldValue(field.name, e.target.value)}
                                />
                            )}
                        </Field>
                        <Field name="password">
                            {({ field, form }) => (
                                <TextInput
                                    id="password"
                                    name="password"
                                    className="font-medium"
                                    placeholder={'Enter your password here'}
                                    autoComplete="password"
                                    password={true}
                                    error={errors.password && touched.password}
                                    message={errors.password}
                                    onChange={e => form.setFieldValue(field.name, e.target.value)}
                                />
                            )}
                        </Field>
                        {/* <Checkbox
                            id="remember"
                            name="remember"
                            className="block"
                            checked={data}
                            label={'remember'}
                            onChange={e => setData(e.target.checked)}
                        /> */}
                        <Button
                            className="w-full mt-3 text-white font-semibold border-primary bg-primary dark:border-secondary dark:bg-secondary"
                            disabled={isSubmitting}
                            type="submit"
                        >
                            Login
                        </Button>
                        <div className="text-center">
                            <p className="font-medium">
                                <Link to="/forgot-password">Forgot your password?</Link>
                            </p>
                        </div>
                    </Form>
                )}
            </Formik>
        </>
    )
}
